import React, { useEffect } from "react";
import { Table, message } from "antd";
import { ColumnsType } from "antd/es/table";
import { contractInfoModel } from "../contractInfoModel";
import { ClearOutlined } from "@ant-design/icons";
import { rosterService } from "../rosterService";
import useNavModel from "@src/model/navModel";
import moment from "moment";

export const ContractDataTable: React.FC = () => {
  const {
    dataSource, pgCfg,
    loading, loadData, loadDs,
    contraceTypeDs, contraceHoldTypeDs,
  } = contractInfoModel();

  const { addNav } = useNavModel();

  useEffect(() => {
    loadDs();
    loadData();
  }, []);

  const isContractExpiring = (endDate: string, cancelReminder: number) => {
    if (!endDate || cancelReminder === 1) return false;
    const end = moment(endDate);
    const now = moment();
    const diffMonths = end.diff(now, 'months');
    return diffMonths <= 1; // 1个月以内到期或已过期
  };

  const contractColumns: ColumnsType<any> = [
    {
      align: 'center',
      title: '序号',
      width: 60,
      render: (v, r, i) => i + 1
    },
    {
      title: '员工工号',
      dataIndex: 'staffId',
      width: 120,
      align: 'center',
    },
    {
      title: '姓名',
      dataIndex: 'employeeName',
      width: 120,
      align: 'center',
      render: (text, record) => (
        <span
          style={{ color: '#1890ff', cursor: 'pointer' }}
          onClick={() => addNav('portal-03-04-02', { id: record.employeeId, mode: 'edit', activeKey: '1' })}
        >
          {text}
        </span>
      ),
    },
    {
      title: '联系电话',
      dataIndex: 'phoneNumber',
      width: 120,
      align: 'center',
    },
    {
      title: '合同类型',
      dataIndex: 'contractType',
      width: 120,
      align: 'center',
      render: (v: any, r: any, i: any) => {
        const item = contraceTypeDs?.find(item => item.value === v);
        return <span style={{ lineHeight: '28px' }}>{item?.label || v}</span>;
      },
    },
    {
      title: '合同户别',
      dataIndex: 'contractCategory',
      width: 150,
      align: 'center',
      render: (v: any, r: any, i: any) => {
        const item = contraceHoldTypeDs?.find(item => item.value === v);
        return <span style={{ lineHeight: '28px' }}>{item?.label || v}</span>;
      },
    },
    {
      title: '合同开始时间',
      dataIndex: 'startDate',
      width: 150,
      align: 'center',
    },
    {
      title: '合同结束时间',
      dataIndex: 'endDate',
      width: 150,
      align: 'center',
      render: (text: string, record: any) => {
        const isExpiring = isContractExpiring(text, record.cancelReminder);
        return (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
            <span style={{
              color: isExpiring ? '#ff4d4f' : 'inherit',
              fontWeight: isExpiring ? 'bold' : 'normal'
            }}>
              {text}
            </span>
            {isExpiring && (
              <ClearOutlined
                style={{ color: '#1890ff', cursor: 'pointer' }}
                onClick={async (e) => {
                  e.stopPropagation();
                  try {
                    await rosterService.cancelReminder(record.id);
                    message.success('取消预警提醒成功');
                    loadData();
                  } catch (error) {
                    message.error('取消预警提醒失败');
                  }
                }}
              />
            )}
          </div>
        );
      }
    },
    {
      title: '合同期限',
      dataIndex: 'contractDuration',
      width: 120,
      align: 'center',
    },
    {
      title: '续签次数',
      dataIndex: 'num',
      width: 120,
      align: 'center',
    }
  ];

  return (
    <Table
      style={{ cursor: "pointer" }}
      loading={loading}
      rowKey={record => record.id as string}
      columns={contractColumns}
      dataSource={dataSource}
      pagination={{
        showSizeChanger: true,
        ...pgCfg,
        defaultPageSize: 25,
        pageSizeOptions: ['15', '25', '50', '100'],
        position: ["bottomRight"],
        showTotal: () => `共${pgCfg.total}条`,
        onChange: (pageNum, pageSize) => {
          loadData({ pageNum, pageSize }).then();
        }
      }}
      scroll={{ x: "max-content", y: "500px" }}
    />
  );
}